import { useSelector } from '../../../react-redux';
import { useMemo } from 'react';

function useFunction(key) {
  const state = useSelector(state => state.get('func'));
  const { functionMap, permReady } = useMemo(() => {
    return {
      functionMap: state.get('functionMap'),
      permReady: state.get('permReady')
    };
  }, [state]);

  if (Array.isArray(key)) {
    return key.some(keyItem => (permReady ? !!functionMap[keyItem] : false));
  }
  return permReady ? !!functionMap[key] : false;
}

export default useFunction;
